export const SET_HOLIDAYS = 'SET_HOLIDAYS';
export const ADD_TO_HOLIDAYS_CACHE = 'ADD_TO_HOLIDAYS_CACHE';
export const UPDATE_HOLIDAY_IN_CACHE = 'UPDATE_HOLIDAY_IN_CACHE';
export const REMOVE_HOLIDAY_FROM_CACHE = 'REMOVE_HOLIDAY_FROM_CACHE';
export const CLEAR_HOLIDAYS_CACHE = 'CLEAR_HOLIDAYS_CACHE';


